import React from 'react'
import { Link } from "gatsby"

import confStyles from './confidence_matchup.module.scss'

const ConfMatchup = ( {season, week, homeTeam, homeTeamSmall, homeConf, homeLogo, awayTeam, awayTeamSmall, awayConf, awayLogo } ) => {

    return (

        <td className={confStyles.confidenceTd}>
            <Link
                className={confStyles.gameLink}
                to={`/games/${season}-week-${week}-${awayTeam.toLowerCase()}-at-${homeTeam.toLowerCase()}-betting-preview/`}
            >
                <div className={confStyles.matchupContainer}>
                    <div className={confStyles.teamContainer} data-orientation='right' data-pick={parseFloat(awayConf) < parseFloat(homeConf) ? false : true}>
                        <div className={confStyles.teamNameDiv} data-orientation='right' data-size='large'>
                            <p className={confStyles.teamNameP}>
                                {awayTeam}
                            </p>
                        </div>
                        <div className={confStyles.teamNameDiv} data-orientation='right' data-size='small'>
                            <p className={confStyles.teamNameP}>
                                {awayTeamSmall}
                            </p>
                        </div>
                        <div className={confStyles.logoDiv}>
                            <img
                                className={confStyles.teamLogo}
                                src={awayLogo}
                                alt={awayTeam}>
                            </img>
                        </div>
                        <div className={confStyles.teamOverlay} data-pick={parseFloat(awayConf) < parseFloat(homeConf) ? true : false}></div>
                    </div>
                    <div className={confStyles.atDiv}>
                        <p className={confStyles.atP}>
                            @
                        </p>
                    </div>
                    <div className={confStyles.teamContainer} data-orientation='left' data-pick={parseFloat(awayConf) > parseFloat(homeConf) ? false : true}>
                        <div className={confStyles.logoDiv}>
                            <img
                                className={confStyles.teamLogo}
                                src={homeLogo}
                                alt={homeTeam}>
                            </img>
                        </div>
                        <div className={confStyles.teamNameDiv} data-orientation='left' data-size='large'>
                            <p className={confStyles.teamNameP}>
                                {homeTeam}
                            </p>
                        </div>
                        <div className={confStyles.teamNameDiv} data-orientation='left' data-size='small'>
                            <p className={confStyles.teamNameP}>
                                {homeTeamSmall}
                            </p>
                        </div>
                        <div className={confStyles.teamOverlay} data-pick={parseFloat(awayConf) > parseFloat(homeConf) ? true : false}></div>
                    </div>
                </div>
            </Link>
        </td>

    )
}

export default ConfMatchup